import React from 'react';

import DatePickerSimple from './DatePickerSimple';
import 'moment/locale/en-gb';
import './styles.scss';
import { formatISO, parseISO } from 'date-fns';

const DatePickerLeisure = ({
  input,
  minDate,
  maxDate,
  meta,
  minDateToday,
  showYear,
  isDisabled,
}) => {
  const handleOnChange = (date) => {
    const newDate = date ? formatISO(date) : '';
    input.onChange(newDate);
  };

  const selectedDate = input?.value ? parseISO(input.value) : '';

  return (
    <div className={meta && meta.error && meta.submitFailed ? ' has-error' : ''}>
      <div className="select-date-input datepicker-custom">
        <DatePickerSimple
          id={input.name.replaceAll('.', '_')}
          withPortal
          monthsShown={2}
          minDate={minDateToday ? new Date() : minDate}
          maxDate={maxDate}
          showYear={showYear}
          selected={selectedDate}
          onChange={handleOnChange}
          isDisabled={isDisabled}
        />
        {meta && meta.touched && meta.error && (
          <div>
            <span className="input-error">{meta.error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DatePickerLeisure;
